import React from 'react'
import { DISABLED_CUBE_COLOR, SELECTED_CUBE_COLOR } from '../../../shared/Modals/PurchaseTokenModal/purchaseTokenModal.data';

const TokenCube = ({ position, onClick }) => {
  // Note: These are 'effective' dimensions after accounting for the 90deg rotation in CourtInnerSvg
  const width = 26.9587;
  const height = 26.9558;

  // Use centralized colors: priority to passed color object, then fallback based on disabled state
  const cubeColors = position.color || (position.disabled ? DISABLED_CUBE_COLOR : SELECTED_CUBE_COLOR);
  
  const topColor = cubeColors.topFace;
  const sideColor = cubeColors.rightFace;
  const edgeColor = cubeColors.leftFace;

  return (
    <svg
      x={position.x - width}
      y={position.y}
      width={width}
      height={height}
      viewBox="0 0 24.2 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      dx={position.xAxis}
      dy={position.yAxis}
      dzone={position.dzone}
      data-disabled={position.disabled ? "true" : ""}
      style={{ cursor: position.disabled ? "not-allowed" : "pointer" }}
    >
      <g transform="scale(1.5, 1.0)">
        {/* Bottom/Edge Piece (Map to leftFace) */}
        <path d="M0.12793 23.6016L14.6366 23.7152L15.8683 25.7256L1.33973 25.7256L0.12793 23.6016Z" fill={edgeColor} />
        {/* Side Piece (Map to rightFace) */}
        <path d="M14.6259 23.7235L14.6329 0.302413L15.8718 2.36848L15.859 25.7171L14.6259 23.7235Z" fill={sideColor} />
        {/* Top Main Piece (Map to topFace) */}
        <path d="M0.387134 0.259203L14.633 0.25915L14.6363 23.736L0.132987 23.6484L0.387134 0.259203Z" fill={topColor} />
      </g>

      {/* Number Overlay */}
      <foreignObject x="0" y="0" width="24.2" height="23" style={{ pointerEvents: 'none' }}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="flex items-center justify-center w-full h-full">
          <span className="text-[10px] font-bold text-black opacity-90 select-none">
            {position?.tokenName}
          </span>
        </div>
      </foreignObject>
    </svg>
  )
}

export default TokenCube